import { track } from '@bnnvara/analytics/src/track';
/* eslint-disable react/jsx-no-target-blank */
import PropTypes from 'prop-types';
import React from 'react';

import { AUDIO_TYPE, VIDEO_TYPE } from '../MediaPlayer/types';
import * as S from './styled';

export const NPOVideoPlayer = ({
  embedId,
  title,
  isBroadcastEnabled,
  type,
}) => {
  if (isBroadcastEnabled) {
    return (
      <>
        <S.Iframe
          src={`https://start-player.npo.nl/embed/${embedId}`}
          title={title}
          width="100%"
          height="100%"
          frameBorder="0"
          scrolling="no"
          allowFullScreen
          webkitallowfullscreen="true"
          mozallowfullscreen="true"
          allow="encrypted-media"
          type={type}
        />
      </>
    );
  }

  return (
    <S.NPOLink>
      Bekijk deze uitzending op &nbsp;
      <a
        href="https://www.npostart.nl"
        target="_blank"
        rel="noopener"
        onClick={() => track('videoplayer-npo-pip', 'click', 'NPO Start')}
      >
        NPO Start
      </a>
    </S.NPOLink>
  );
};

NPOVideoPlayer.propTypes = {
  type: PropTypes.oneOf([VIDEO_TYPE, AUDIO_TYPE]).isRequired,
  title: PropTypes.string.isRequired,
  embedId: PropTypes.string.isRequired,
  isBroadcastEnabled: PropTypes.bool.isRequired,
};
